import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTpLinkComponent } from './simple-icons-tp-link.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTpLinkComponent ],
    exports:      [ SimpleIconsTpLinkComponent ],
    bootstrap:    []
})
export class SimpleIconsTpLinkModule {}
